<template>
  <mx-dialog class="not-auth-dialog">
    <div class="not-auth-dialog-body">
      <div class="not-auth-dialog-content">
        <div class="icon-warp">
          <i class="iconfont fail iconicon_common_warn"></i>
        </div>
        <div class="main-tip">无“{{ teamName }}”团队文件的访问权限</div>
        <div class="sub-tip">请联系团队管理员“{{ managerName }}”加入团队</div>
      </div>

      <div class="footer">
        <div class="comfirm" @click="jumpToIndex">
          <span>返回首页</span>
        </div>
      </div>
    </div>
  </mx-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { get } from 'lodash-es';
import Vue from 'vue';

export default {
  name: 'NotAuthDialog',
  computed: {
    ...mapState({
      dialogData: state => get(state.dialogInfo, 'dialogData', {})
    }),
    teamName() {
      const teamName = this.dialogData.file.teamName || '';
      return this.handleTextEllpsis(teamName, 17);
    },
    managerName() {
      const managerName = this.dialogData.file.managerName || '';
      return this.handleTextEllpsis(managerName, 7);
    }
  },
  methods: {
    // 以中文字符作为标准，超多最大长度限制，以省略号代替
    handleTextEllpsis(name, maxLen) {
      const len = name.length || 0;
      const resName = len > maxLen ? `${name.slice(0, maxLen)}...` : name;
      return resName;
    },
    jumpToIndex() {
      Vue.MXDialog.hide();
      window.location.href = '/dashboard.html';
    }
  }
};
</script>

<style lang="scss" scoped>
@import './NotAuthDialog.scss';
</style>
